<div class="bespoke-slide__gallery gallery-slide {{ classes }}">
    <slot>

        {{#if slide.bg_img}}
            <div class="gallery__img-outer">
                <div class="gallery__img-inner">
                    <img src="{{slide.bg_img}}" alt="" />
                </div>
                {{#if slide.credit}}
                    <div class="gallery__credit">
                        <div class="gallery__credit-inner">{{ slide.credit }}</div>
                    </div>
                {{/if}}
            </div>
        {{/if}}

        {{#if slide.text}}
            <div class="gallery__caption-outer">
                <div class="gallery__caption">{{ slide.text }}</div>
            </div>
        {{/if}}
    </slot>
</div>

<script>
export default {
    data() {
        return {
            slide: {},
            i: 0,
        }
    },

    computed: {
        classes: (current_slide, i) => {
            let classes = i == current_slide ? 'bespoke-active' : 'bespoke-inactive';
            if (i < current_slide) classes += ' bespoke-before'; 
            if (i > current_slide) classes += ' bespoke-after';
            return classes;
        }
    },
}
</script>